"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthService = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var _excluded = ["token"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var AuthService = exports.AuthService = /*#__PURE__*/(0, _createClass2["default"])(function AuthService() {
  (0, _classCallCheck2["default"])(this, AuthService);
});
(0, _defineProperty2["default"])(AuthService, "signIn", function (data) {
  return _Api["default"]["default"]().post("/signin", data);
});
// TODO: Start using signout endpoint
(0, _defineProperty2["default"])(AuthService, "signOut", function (_ref) {
  var token = _ref.token;
  return _Api["default"].withAuth(token).get('/signout');
});
(0, _defineProperty2["default"])(AuthService, "changePassword", function (_ref2) {
  var token = _ref2.token,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  return _Api["default"].withAuth(token).post('/passwordChange', _objectSpread({}, params));
});
(0, _defineProperty2["default"])(AuthService, "refreshSession", function (_ref3) {
  var token = _ref3.token;
  return _Api["default"].withAuth(token).get('/session');
});